import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import DeleteBreakModal from 'components/DeleteConfirmation/DeleteConfirmationModal';
import {endDeleteAction, submitDeleteAction} from "./actions";

const mapStateToProps = (state) => ({
    deleting: state.deleteConfirmation.deleteChallengeSubmitted,
    modalOpen: state.deleteConfirmation.deleting,
    resource: state.deleteConfirmation.deleteResource,
    resourceId: state.deleteConfirmation.deleteResourceId
});

const mapDispatchToProps = (dispatch) => ({
    confirm: (challenge) => dispatch(submitDeleteAction(challenge)),
    cancel: () => dispatch(endDeleteAction())
});

const DeleteConfirmationModalContainerConnected = connect(mapStateToProps, mapDispatchToProps);

const DeleteConfirmationModalContainer = compose(
    DeleteConfirmationModalContainerConnected
)(DeleteBreakModal);

export default DeleteConfirmationModalContainer;



// WEBPACK FOOTER //
// ./public/pages/DeleteConfirmation/DeleteConfirmationModalContainer.jsx